Vue.component('create-question', {
    props: ['id'],

    data () {
        return {
            createForm: $.extend(true, new Form({
                data: {
                    name: '',
                    type: '',
                    required: '',
                    options: []
                }
            }), {}),

            newOption: ''
        };
    },

    methods: {
        submit () {
            Http.post('/api/questions/create_question/' + this.id, this.createForm).then((response) => {
                this.createForm.resetForm();

                $('#create-question').modal('hide');

                this.$emit('on-created');
            });
        },

        addOption (e) {
            e.preventDefault();

            this.createForm.data.options.push(this.newOption);

            this.newOption = '';
        },

        deleteOption(index) {
            this.createForm.data.options.splice(index, 1);
        }
    }
});